import React from 'react';
import styled from '@emotion/styled';
import { SteeringIcon } from 'components/views/atoms/SteeringIcon';

const Frame = styled.div({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

const IconBox = styled(SteeringIcon)<SteeringIndicatorProps>(props => ({
    transform: `rotate(${-props.angle}deg)`,
}));

export type SteeringIndicatorProps = {
    className?: string;
    angle: number;
}

export const SteeringIndicator = (props: SteeringIndicatorProps) => {
    return (
        <Frame className={props.className}>
            <IconBox angle={props.angle} ></IconBox>
        </Frame>
    );
};
